export const externalLinksTypes = {
	PK: 'PK',
	ISP: 'ISP',
	CZP: 'CZP',
	HUGO: 'HUGO',
	DEBTS: 'DEBTS',
	LISA: 'LISA',
	LISA2: 'LISA2',
	SAN_MARCO: 'SAN_MARCO',
};

export const externalLinksIdsInParametersCodelist = {
	PK: 'EXTERNAL_LINK_GEFPK',
	ISP: 'EXTERNAL_LINK_JOKISP',
	CZP: 'EXTERNAL_LINK_CZP',
	HUGO: 'EXTERNAL_LINK_HUGO',
	DEBTS: 'EXTERNAL_LINK_DEBTS',
	LISA: 'EXTERNAL_LINK_LISA',
	LISA2: 'EXTERNAL_LINK_LISA2',
	SAN_MARCO: 'EXTERNAL_LINK_SANMARCO',
};
